module.exports = __webpack_public_path__ + "static/media/icon-cross.b0200bf7.svg";